export enum ImsInventorySource {
  RedoIms = "redo_ims",
  Finale = "finale",
}
